import { render, staticRenderFns } from "./HealthQuestionsForm.vue?vue&type=template&id=3d37f2c1"
import script from "./HealthQuestionsForm.vue?vue&type=script&lang=js"
export * from "./HealthQuestionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports